module.exports = __webpack_public_path__ + "img/组 3034.c907aead.png";